import { inject, Injectable } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfigPresetProvider } from '@ngx-formly/core/lib/models';
import { DataSetupFacade } from '@portal/application/data-access';
import { map } from 'rxjs';
import { mapDataSetupSelectOptionToFormly } from '../util';

@Injectable()
export class MinimumAmountReceiveNotificationPresetProvider implements FormlyFieldConfigPresetProvider {
  private readonly dataSetupFacade = inject(DataSetupFacade);

  getConfiguration(): FormlyFieldConfig {
    return {
      type: 'radio',
      props: {
        options: this.dataSetupFacade.dataSetup$?.pipe(
          map(dataSetup => mapDataSetupSelectOptionToFormly(dataSetup?.minimumAmountReceiveNotifications)),
        ),
      },
    };
  }
}

export function registerMinimumAmountReceiveNotificationPreset(): ConfigOption {
  return {
    presets: [
      {
        name: 'minimumAmountReceiveNotification',
        config: new MinimumAmountReceiveNotificationPresetProvider(),
      },
    ],
  };
}
